import React from 'react';
import PropTypes from 'prop-types';
import { Form, withFormik } from 'formik';
import * as Yup from 'yup';
import { Input as FormInput } from '../../components/Form/Input';
import { withInputClassNames, withTextAreaClassNames } from './HOC';
import classnames from 'classnames';
import './OnboardingStepRedesign.css';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'


const Input = withInputClassNames(FormInput);
const TextArea = withTextAreaClassNames(FormInput);
const YupString = Yup.string().required('Required');
const YupEmail = Yup.string()
  .email('Invalid email')
  .required('Required');

const LoggedInValidationSchema = Yup.object({ projectName: YupString });
const DefaultValidationSchema = Yup.object({
  projectName: YupString,
  firstName: YupString,
  lastName: YupString,
  email: YupEmail,
});

const ProjectForm = props => (
  <div className="onboarding-step-redesign text-center">
    <div className="red-step-title mb-4">You're almost done!</div>
    <div className="onboarding-step-redesign__step-subtitle">
      Let us know any additional project details or comments prior to
      submitting.
    </div>
    <div className="flex justify-content-center onboarding-step-redesign__form-container">
      <div className="container">
        <Form autoComplete="off" noValidate>
          <div
            className={classnames(
              'form-row onboarding-step-redesign__row-center',
              { 'mobile-form': props.isLogin },
            )}
          >
            <div className="onboarding-step-redesign__full-center">
              <Input
                label="Project Name"
                name="projectName"
                onChange={props.updateFormInfo}
                hasInput={!!props.formInfo.projectName}
              />
              <TextArea
                label="Project Details "
                name="comments"
                onChange={props.updateFormInfo}
                hasInput={!!props.formInfo.comments}
              />
            </div>
          </div>
          {!props.isLogin && (
            <div className="personal-info">
              <div className="form-row onboarding-step-redesign__row-center">
                <div className="onboarding-step-redesign__full-center">
                  <div className="onboarding-step-redesign__inputs-container">
                    <Input
                      label="First Name"
                      name="firstName"
                      inputContainerClassName="onboarding-step-redesign__col onboarding-step-redesign__col__left"
                      onChange={props.updateFormInfo}
                      hasInput={!!props.formInfo.firstName}
                    />
                    <Input
                      label="Last Name"
                      name="lastName"
                      onChange={props.updateFormInfo}
                      inputContainerClassName="onboarding-step-redesign__col onboarding-step-redesign__col__right"
                      hasInput={!!props.formInfo.lastName}
                    />
                  </div>
                </div>
              </div>
              <div className="form-row onboarding-step-redesign__row-center">
                <div className="onboarding-step-redesign__full-center">
                  <Input
                    label="Email"
                    name="email"
                    type="email"
                    onChange={props.updateFormInfo}
                    hasInput={!!props.formInfo.email}
                  />
                </div>
              </div>
              <div className="form-row onboarding-step-redesign__row-center">
                <div className="onboarding-step-redesign__full-center onboarding-phone-number country_code">

                 {/*<Input
                    label="Phone Number"
                    name="phoneNumber"
                    inputMode="numeric"
                    onChange={props.updateFormInfo}
                    hasInput={!!props.formInfo.phoneNumber}
                  />*/}
                    <PhoneInput
                      country={'us'}
                      enableAreaCodes={true}
                      countryCodeEditable={true}
                      values={props.formInfo.phoneNumber}
                      onChange={phone => {
                        props.formInfo.phoneNumber = phone;
                      }}
                    />
                </div>
              </div>
              <div className="form-row onboarding-step-redesign__row-center">
                <div className="onboarding-step-redesign__full-center phone-number-note">
                  So our account managers can call to discuss your video
                </div>
              </div>
              <div className="form-row onboarding-step-redesign__row-center terms">
                <div className="onboarding-step-redesign__full-center terms-and-conditions">
                  By creating an account you agree to the{' '}
                  <a
                    className="terms-and-conditions link"
                    href="https://dreamitreel.com/terms-of-service/"
                    target="_blank"
                  >
                    Terms and Conditions
                  </a>
                </div>
              </div>
            </div>
          )}
          {props.buttons}
        </Form>
      </div>
    </div>
  </div>
);

ProjectForm.propTypes = {
  formInfo: PropTypes.object,
  projectName: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  updateFormInfo: PropTypes.func,
  isLogin: PropTypes.bool,
};

export const OnboardingProjectFormStep = withFormik({
  enableReinitialize: true,
  handleSubmit: (values, { props }) => {
    values.phoneNumber = props.formInfo.phoneNumber;
    props.submitForm(values); 
  },
  mapPropsToValues: ({
    formInfo: {
      projectName,
      comments,
      firstName,
      lastName,
      email,
      phoneNumber,
      country,
      dialCode,
    },
  }) => ({
    projectName,
    comments,
    firstName,
    lastName,
    email,
    phoneNumber,
    country,
    dialCode,
  }),
  validateOnBlur: false,
  validateOnChange: false,
  validationSchema: ({ isLogin }) =>
    isLogin ? LoggedInValidationSchema : DefaultValidationSchema,
  displayName: 'OnboardingProjectFormStep',
})(ProjectForm);



// WEBPACK FOOTER //
// ./src/containers/OnboardingRedesign/OnboardingProjectFormStep.js